'use client';

import React from 'react';
import { cn } from '@/lib/utils/cn';
import { Logo } from '@/components/ui/logo';
import { SocialLinks } from '@/components/ui/social-links';
import { ArrowUp } from 'lucide-react';
import { About, Contact } from '@/types';
// import { FooterAPI } from "@/lib/services/footer.service";

export function MegaFooter({ contactData, aboutData }: { contactData: Contact, aboutData: About }) {
  // console.log(contactData);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <section className="min-h-screen w-full bg-black text-white flex flex-col justify-between py-16 footer-container relative">
        {/* Back to top button */}
        <button
          onClick={scrollToTop}
          className={cn(
            'absolute top-0 right-2 p-3 bg-zinc-800 hover:bg-zinc-700 rounded-full shadow-lg transition-all duration-300 z-10'
          )}
          aria-label="Back to top"
        >
          <ArrowUp className="w-4 h-4 text-white" />
        </button>

        <div className="footer-sep">
          <div className="footer-sep-mask"></div>
        </div>
        {/* Top section with logo and copyright */}
        <div className="w-full px-4 flex flex-row md:flex-row justify-between items-start">

          {/* Logo */}
          <div className="mb-12 md:mb-0 mr-5">
            <div className="w-24 h-24 relative">
              <Logo />
            </div>
          </div>

          {/* Copyright text - positioned at top right */}
          <div className="text-[10px] uppercase tracking-wider max-w-md text-right">
            <p className="leading-tight">{contactData.description}</p>
            <p className="mt-4 text-right">{new Date().getFullYear()}®</p>
          </div>
        </div>


        {/* Middle section with binary code and keywords */}
        <div className="w-full px-4 flex flex-col justify-center grow">
          <div className="flex justify-between items-start lg:items-center mb-32 flex-col lg:flex-row gap-y-5 lg:gap-0">
            {/* Binary code section - left aligned */}
            <div className="font-mono text-[10px] opacity-70">{contactData.location}</div>

            {/* Keywords section - right aligned */}
            <div className="font-mono text-[10px] uppercase tracking-wider opacity-70">
              {contactData.keywords}
            </div>
          </div>
        </div>

        {/* Social links grid */}
        <div className="w-full px-4 mt-auto">
          <SocialLinks contactData={contactData} />
        </div>

        {/* Bottom copyright */}
        {/* <div className="w-full px-4 pt-6 flex justify-between items-center text-[10px]">
          <div className="text-zinc-600">ALL RIGHTS RESERVED SINCE 1990</div>
          <div className="text-zinc-600">MADE AT OMA FOR BOSS</div>
        </div> */}
      </section>
    </>
  );
}
